"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ProductListItem;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@sart/styles");
var _icons = require("@sart/icons");
var _content = require("@sart/content");
var _Text = _interopRequireDefault(require("./Text"));
var _Price = _interopRequireDefault(require("./Price"));
var _Space = _interopRequireDefault(require("./Space"));
var _RemoteProductIcon = _interopRequireDefault(require("./RemoteProductIcon"));
var _client = require("@sart/client");
var _excluded = ["product", "disabled", "onPress", "style", "placeholderStyle", "loadingBackgroundStyle", "bodyStyle", "headerStyle", "titleStyle", "priceStyle", "descriptionStyle", "basket", "allowDelete", "removeProductFunction", "imageColor"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function typeOfProduct(_ref) {
  var localData = _ref.localData,
    localMinutes = _ref.localMinutes,
    localSMS = _ref.localSMS;
  if (localData > 0 && !localMinutes && !localSMS) {
    return 'data';
  }
  if (localMinutes > 0 && !localData && !localSMS) {
    return 'minutes';
  }
  if (localSMS > 0 && !localData && !localMinutes) {
    return 'sms';
  }
  return 'hybrid';
}
function ProductListItem(props) {
  var product = props.product,
    disabled = props.disabled,
    onPress = props.onPress,
    style = props.style,
    placeholderStyle = props.placeholderStyle,
    loadingBackgroundStyle = props.loadingBackgroundStyle,
    bodyStyle = props.bodyStyle,
    headerStyle = props.headerStyle,
    titleStyle = props.titleStyle,
    priceStyle = props.priceStyle,
    descriptionStyle = props.descriptionStyle,
    basket = props.basket,
    allowDelete = props.allowDelete,
    removeProductFunction = props.removeProductFunction,
    imageColor = props.imageColor,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _useState = (0, _react.useState)(product),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    productItem = _useState2[0],
    setProductItem = _useState2[1];
  var content = (0, _content.useContent)();
  (0, _react.useEffect)(function () {
    var isMounted = true;
    function checkProduct() {
      return _checkProduct.apply(this, arguments);
    }
    function _checkProduct() {
      _checkProduct = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var loadedProduct, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (!(product.displayDetails === undefined)) {
                _context.next = 2;
                break;
              }
              _context.next = 1;
              return _client.client.callApi('catalog', 'getProduct', [_client.client.cache.catalogId, product.productId]);
            case 1:
              loadedProduct = _context.sent;
              if (isMounted) {
                setProductItem(loadedProduct);
              }
            case 2:
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](0);
              return _context.abrupt("return", undefined);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 3]]);
      }));
      return _checkProduct.apply(this, arguments);
    }
    void checkProduct();
    return function () {
      isMounted = false;
    };
  }, [product]);
  function getNameTranslation(product) {
    var toReturn = product.productName;
    if (product.displayDetails) {
      product.displayDetails.map(function (detail) {
        if (detail.language === _client.client.cache.language) {
          toReturn = detail.displayName;
        }
      });
    }
    return toReturn;
  }

  /* 
  Functions to get display information from product's Display Details 
  */
  function getDisplayDetailsForLanguage(product) {
    //Get the display details for the language that is selected in the cache
    var displayDetails = undefined;
    //identify the correct display details to use based on language
    if (product.displayDetails) {
      product.displayDetails.map(function (detail) {
        if (detail.language === _client.client.cache.language) {
          displayDetails = detail;
        }
      });
    }
    return displayDetails;
  }
  function getColourByCategory(displayDetails, category) {
    if (!category) {
      return undefined;
    }
    var toReturn = undefined;
    var hexCodeRegex = /^#(?:[0-9a-fA-F]{3}){1,2}$/;

    //get the relevant font colour based on the category
    if (displayDetails && displayDetails.colors && displayDetails.colors.length) {
      displayDetails.colors.map(function (color) {
        //we also only accept hex values, so use regex to make sure it matches the pattern
        if (color.category === category && hexCodeRegex.test(color.color)) {
          toReturn = color.color;
        } else if (color.category === category && color.color === 'transparent') {
          return undefined;
        }
      });
    }
    return toReturn;
  }
  function getDescriptionTranslation(product) {
    var toReturn = product.description;
    if (product.displayDetails) {
      product.displayDetails.map(function (detail) {
        if (detail.language === _client.client.cache.language) {
          toReturn = detail.displayDescription;
        }
      });
    }
    return toReturn;
  }
  function getRecurringString() {
    var toReturn;
    // Use the frequency to work out if we use 'per' or 'every x'
    if (product.recurringFrequency === 1) {
      toReturn = content.product.per;
    } else if (product.recurringFrequency > 1) {
      toReturn = content.product.every + product.recurringFrequency;
    }
    //Use frequency unit to work out how often it recurs 
    if (product.recurringFrequencyUnit.toUpperCase() === 'DAYS') {
      toReturn = toReturn + content.product.days;
    } else if (product.recurringFrequencyUnit.toUpperCase() === 'WEEKS') {
      toReturn = toReturn + content.product.weeks;
    } else if (product.recurringFrequencyUnit.toUpperCase() === 'MONTHS') {
      toReturn = toReturn + content.product.months;
    }
    // If the frequency is 1, make the postfix singular
    if (product.recurringFrequency === 1 && toReturn) {
      var _toReturn;
      toReturn = (_toReturn = toReturn) === null || _toReturn === void 0 ? void 0 : _toReturn.substring(0, toReturn.length - 1);
    }
    return toReturn;
  }
  /* 
  End Display Details Functions 
  */

  var displayDetails = getDisplayDetailsForLanguage(productItem);
  // const productImage = getProductIcon(displayDetails)
  var type = typeOfProduct(productItem);
  var imageColorStyle = imageColor ? imageColor : _styles.colors.darkCharcoal;
  var name = getNameTranslation(productItem);
  var description = getDescriptionTranslation(productItem);
  var titleColour = getColourByCategory(displayDetails, 'TitleText');
  var descriptionColour = getColourByCategory(displayDetails, 'DescriptiveText');
  var backgroundColour = getColourByCategory(displayDetails, 'Background');
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, (0, _extends2["default"])({
    style: [styles.container, style, backgroundColour ? {
      backgroundColor: backgroundColour
    } : {}],
    onPress: onPress,
    disabled: disabled
  }, rest), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.placeholder, placeholderStyle]
  }, /*#__PURE__*/_react["default"].createElement(_RemoteProductIcon["default"], {
    product: productItem,
    size: 40,
    webStyle: styles.productImageWeb
  })), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.body, bodyStyle]
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.header, headerStyle]
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [styles.title, titleStyle, titleColour ? {
      color: titleColour
    } : {}]
  }, name), /*#__PURE__*/_react["default"].createElement(_Price["default"], {
    value: productItem.upfrontCost > 0 ? productItem.upfrontCost : productItem.recurringCost,
    style: [styles.title, priceStyle, descriptionColour ? {
      color: descriptionColour
    } : {}],
    code: product.currency
  })), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    hieght: 32
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.itemSubHeaderItemStyle
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [styles.recurring, styles.description, descriptionStyle, descriptionColour ? {
      color: descriptionColour
    } : {}]
  }, description), product.recurring && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [styles.description, descriptionStyle, descriptionColour ? {
      color: descriptionColour
    } : {}]
  }, getRecurringString()), allowDelete && /*#__PURE__*/_react["default"].createElement(_icons.Delete, {
    color: _styles.colors.exisDarkCharcoal,
    size: 33,
    onPress: removeProductFunction
  }))));
}
ProductListItem.propTypes = {
  product: _propTypes["default"].object,
  onPress: _propTypes["default"].func
};
var styles = _reactNative.StyleSheet.create({
  container: {
    height: 72,
    flexDirection: 'row',
    borderRadius: 8,
    backgroundColor: _styles.backgroundColors.clear,
    overflow: 'hidden',
    borderColor: _styles.colors.subtle,
    borderWidth: 1
  },
  placeholder: {
    // flex: 1,
    width: 72,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: _styles.backgroundColors.brightOrange
  },
  loadingBackground: {
    // flex: 1,
    width: 72,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: _styles.backgroundColors.darkCharcoal,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8
  },
  body: {
    flex: 1,
    padding: 12
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: _objectSpread(_objectSpread({
    fontSize: 14,
    lineHeight: 16
  }, _styles.typography.lightbold), {}, {
    color: _styles.colors.white,
    maxWidth: '80%'
  }),
  description: {
    fontSize: 14,
    lineHeight: 24,
    color: _styles.colors.white
  },
  itemSubHeaderItemStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  productImageMobile: {
    // marginTop: 12,
    width: 72,
    alignItems: 'center',
    justifyContent: 'center'
    // backgroundColor: backgroundColors.exisOrange,
  },
  productImageWeb: {
    // marginTop: 12,
    objectFit: 'contain'
  },
  recurring: {
    textAlign: 'right'
  }
});